// components/RecommendedBooks.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography, Card, Paper, Box } from '@mui/material';
import axios from 'axios';
import defaultThumbnail from '../assets/logo4.png';

const RecommendedBooks = ({ course, subject, semester, currentBookId }) => {
  const [recommendedBooks, setRecommendedBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchRecommendations = async () => {
      const params = {
        collegeId: JSON.parse(localStorage.getItem('user'))?.collegeId || '',
        currentBookId: currentBookId,
        subjectName: subject,
        semester: semester,
        courseName: course,
        limit: 5,
      };
    

    
      try {
        const response = await axios.get('https://backend.scholarkart.in/api/books/recommendations_ebrary', { params });
        const books = response.data.books || [];
    
        const formatted = books
          .filter((b) => b._id !== currentBookId)
          .map((b) => ({
            id: b._id,
            title: b.bookTitle || "No title",
            authors: b.authorName || "Unknown",
            thumbnail: b.coverImageURL || defaultThumbnail,
          }));
    
        setRecommendedBooks(formatted);
      } catch (err) {
        console.error("❌ Failed to fetch recommended books:", err?.response?.data || err.message);
      } finally {
        setLoading(false);
      }
    };
    

    fetchRecommendations();
  }, [course, subject, semester, currentBookId]);

  return (
    <Paper
      sx={{
        padding: '16px',
        borderRadius: '8px',
        border: '1px solid #ccc',
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
        backgroundColor: 'transparent',
      }}
    >
      <Typography variant="h6" color="primary" sx={{ fontWeight: 'bold', marginBottom: 2 }}>
        Recommended Readings
      </Typography>

      {loading ? (
        <Typography variant="body2">Loading...</Typography>
      ) : recommendedBooks.length > 0 ? (
        recommendedBooks.map((book) => (
          <Card
            key={book.id}
            sx={{
              mb: 2,
              p: 2,
              
              borderRadius: '8px',
              backgroundColor: 'transparent',
              '&:hover': {
                borderColor: '#007bff',
                backgroundColor: '#f9f9f9',
              },
            }}
          >
            <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
            <img src={book.thumbnail} alt="Thumbnail" style={{ width: '30%', height: '45%' }} />
            <Box sx={{ flex: 1 }}>
            <Typography
              variant="subtitle1"
              sx={{ color: 'primary.main', cursor: 'pointer' }}
              onClick={() => navigate(`/mylibrary/${book.id}`)}
            >
              <strong>{book.title}</strong>
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {book.authors}
            </Typography>
            </Box>
            </Box>
          </Card>
        ))
      ) : (
        <Typography variant="body2" color="text.secondary">No similar readings found.</Typography>
      )}
    </Paper>
  );
};

export default RecommendedBooks;
